import { Typography } from '@mui/material'

const StatusWithColor = ({ status, color, customStyle }) => (
  <Typography variant="p" sx={[styles.root, customStyle]} style={{ color: [color] }}>
    {status}
  </Typography>
)

const styles = {
  root: {
    textTransform: 'capitalize',
    fontSize: '13px',
  },
}

export default StatusWithColor
